import { Card, Text } from '@shared/components';
import { dayjs } from '@shared/utils';

interface EventDateCardProps {
  date: Date;
}

export default function EventDateCard(props: Readonly<EventDateCardProps>) {
  const { date } = props;

  const day = dayjs(date);
  const dateNo = day.format('D');
  const dateName = day.format('dddd');

  return (
    <Card
      sx={(theme) => ({
        bgcolor: theme.palette.grey[100],
        borderRadius: theme.shape.rounded(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(1),
        p: theme.spacing(4, 2),
        flexBasis: '100px',
        boxShadow: 0,
      })}
    >
      <Text variant='h5'>วันที่ {dateNo}</Text>
      <Text variant='body2' sx={(theme) => ({ color: theme.palette.text.secondary })}>
        {dateName}
      </Text>
    </Card>
  );
}
